export default __webpack_public_path__ + "static/media/sap-icon.c3c8c925.svg";